import { RouteRecordRaw } from 'vue-router'

const LeadsPage = () =>
  import(/* webpackChunkName: "leads-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'leads',
    name: 'leads',
    component: LeadsPage,
    meta: {
      title: 'Leads',
      auth: {
        requiredPermission: 'leads.view',
        requiredModule: 'leads',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
